const activeUserReducer = (userInfo = {}, action) => {
  if (action.type === "ACTIVE_USER_INFO") {
    return action.payload;
  }
  return userInfo;
};

export default activeUserReducer;
